import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
const CRISP_SCRIPT_URL = "https://client.crisp.chat/l.js";
const CRISP_WEBSITE_ID = "adafe1fb-0211-4e78-a56e-d3ebc63a03ff";
let CrispSupport = class CrispSupport extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "userName", void 0);
    _defineProperty(this, "userEmail", void 0);
    _defineProperty(this, "tokenId", void 0);
    _defineProperty(this, "avatarUrl", void 0);
    _defineProperty(this, "organization", void 0);
    _defineProperty(this, "companyUrl", void 0);
    _defineProperty(this, "aiCredits", void 0);
    _defineProperty(this, "role", void 0);
    _defineProperty(this, "locale", void 0);
  }
  mounted() {
    const crispWindow = window;
    // Guard against a double load when the support tag appears more than once on a page.
    if (crispWindow.CRISP_WEBSITE_ID) {
      return;
    }
    // Globals must be set before the loader script runs.
    crispWindow.$crisp = crispWindow.$crisp || [];
    crispWindow.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
    crispWindow.CRISP_RUNTIME_CONFIG = {
      locale: this.locale
    };
    if (this.tokenId) {
      crispWindow.CRISP_TOKEN_ID = this.tokenId;
    }
    this.identifyUser(crispWindow.$crisp);
    this.loadCrispScript();
  }
  /**
   * Push the current user identity to Crisp. Every field is optional so anonymous visitors still get the chatbox without any identification.
   */
  identifyUser(crisp) {
    if (this.userEmail) {
      crisp.push(["set", "user:email", [this.userEmail]]);
    }
    if (this.userName) {
      crisp.push(["set", "user:nickname", [this.userName]]);
    }
    if (this.avatarUrl) {
      crisp.push(["set", "user:avatar", [this.avatarUrl]]);
    }
    const sessionData = [];
    const segmentList = [];
    sessionData.push(["current_page", window.location.href]);
    if (this.role) {
      sessionData.push(["role", this.role]);
      segmentList.push(this.role);
    }
    if (this.aiCredits) {
      sessionData.push(["ai_credits", this.aiCredits]);
    }
    if (this.organization) {
      sessionData.push(["boutique", this.organization]);
      let company = [this.organization];
      if (this.companyUrl) {
        company = [this.organization, {
          url: this.companyUrl
        }];
        sessionData.push(["boutique-url", this.companyUrl]);
      }
      crisp.push(["set", "user:company", company]);
      segmentList.push(this.organization);
    }
    if (segmentList.length > 0) {
      crisp.push(["set", "session:segments", [segmentList]]);
    }
    if (sessionData.length > 0) {
      crisp.push(["set", "session:data", [sessionData]]);
    }
  }
  loadCrispScript() {
    if (document.querySelector(`script[src="${CRISP_SCRIPT_URL}"]`)) {
      return;
    }
    const script = document.createElement("script");
    script.src = CRISP_SCRIPT_URL;
    script.async = true;
    document.getElementsByTagName("head")[0].appendChild(script);
  }
};
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "userName", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "userEmail", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "tokenId", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "avatarUrl", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "organization", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "companyUrl", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "aiCredits", void 0);
__decorate([Prop({
  default: ""
})], CrispSupport.prototype, "role", void 0);
__decorate([Prop({
  default: "en"
})], CrispSupport.prototype, "locale", void 0);
CrispSupport = __decorate([Component], CrispSupport);
export default CrispSupport;